import { Id, PolicyAction, PolicyOperator, PolicyReceiptRule } from 'src/types'

export const initialValues = {} as PolicyReceiptRule

export function getDefaultPolicyReceiptRulesValues({
  policy_id = ''
}: {
  policy_id: Id
}): PolicyReceiptRule {
  return {
    action: PolicyAction.ALERT,
    active: true,
    any_value: false,
    currency_id: '',
    description: '',
    operator: PolicyOperator.LESS_THAN_OR_EQUAL_TO,
    policy_id: policy_id === '' ? null : +policy_id || null,
    policy_receipt_rule_id: new Date().toJSON(),
    policy_receipt_rule_prefix: '',
    reason_id: '',
    reference_id: '',
    service_id: '',
    value: 0
  }
}
